import {
  FIRST_NAME_SENDER_SINGLE,
  LAST_NAME_SENDER_SINGLE,
  NATIONAL_CODE_SENDER_SINGLE,
  POSTAL_CODE_SENDER_SINGLE,
  MOBILE_NUMBER_SENDER_SINGLE,
  PHONE_NUMBER_SENDER_SINGLE,
  ADDRESS_SENDER_SINGLE,
  EMAIL_SENDER_SINGLE,
  COMPANY_SENDER_SINGLE,
  LAT_SENDER_SINGLE,
  LNG_SENDER_SINGLE,
  CITY_NAME_SENDER_SINGLE,
  CITY_ID_SENDER_SINGLE,
  STATE_NAME_SENDER_SINGLE,
  STATE_ID_SENDER_SINGLE,
  NEED_SENDER_SINGLE,
  RESET_STATE_SENDER_SINGLE
} from "../../Types";

const initialState = {
  first_name: '',
  last_name: '',
  national_code: '',
  postal_code: '',
  mobile_number: '',
  phone_number: '',
  address: '',
  email: '',
  company: '',
  lat: 35.7,
  lng: 51.4,
  city_name: '',
  city_id: '',
  state_name: '',
  state_id: '',
  need: true
}

export const senderReducer = (state = initialState, action) => {
  switch (action.type) {
    case FIRST_NAME_SENDER_SINGLE: {
      return {
        ...state,
        first_name: action.payload,
      };
    }
    case LAST_NAME_SENDER_SINGLE: {
      return {
        ...state,
        last_name: action.payload,
      };
    }
    case NATIONAL_CODE_SENDER_SINGLE: {
      return {
        ...state,
        national_code: action.payload,
      };
    }
    case POSTAL_CODE_SENDER_SINGLE: {
      return {
        ...state,
        postal_code: action.payload,
      };
    }
    case MOBILE_NUMBER_SENDER_SINGLE: {
      return {
        ...state,
        mobile_number: action.payload,
      };
    }
    case PHONE_NUMBER_SENDER_SINGLE: {
      return {
        ...state,
        phone_number: action.payload,
      };
    }
    case EMAIL_SENDER_SINGLE: {
      return {
        ...state,
        email: action.payload,
      };
    }
    case COMPANY_SENDER_SINGLE: {
      return {
        ...state,
        company: action.payload,
      };
    }
    case CITY_NAME_SENDER_SINGLE: {
      return {
        ...state,
        city_name: action.payload,
      };
    }
    case CITY_ID_SENDER_SINGLE: {
      return {
        ...state,
        city_id: action.payload,
      };
    }
    case STATE_NAME_SENDER_SINGLE: {
      return {
        ...state,
        state_name: action.payload,
      };
    }
    case STATE_ID_SENDER_SINGLE: {
      return {
        ...state,
        state_id: action.payload,
      };
    }
    case ADDRESS_SENDER_SINGLE: {
      return {
        ...state,
        address: action.payload,
      };
    }
    case LAT_SENDER_SINGLE: {
      return {
        ...state,
        lat: action.payload,
      };
    }
    case LNG_SENDER_SINGLE: {
      return {
        ...state,
        lng: action.payload,
      };
    }
    case NEED_SENDER_SINGLE: {
      return {
        ...state,
        need: action.payload,
      };
    }
    case RESET_STATE_SENDER_SINGLE:
      return initialState;

    default:
      return state;
  }
};
